import React from 'react';
import Helmet from 'react-helmet';

export default ({ statusCode, redirectUrl }) => (
  <Helmet>
    <meta name="prerender-status-code" content={redirectUrl ? '303' : statusCode} />
    {redirectUrl && <meta name="prerender-header" content={`Location: ${redirectUrl}`} />}
  </Helmet>
);
